<template>
  <div class="full-size flex flex-column">
    <div class="full-size flex-block-center" v-if="!template">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <div class="flex-grow-1 pa-10 flex-column flex" v-if="template">
      <hi-row py-lg :px="0">
        <div>
          Template editor uses Markdown syntax.
          <a href="https://www.markdownguide.org/basic-syntax/" target="_blank">
            See help here</a
          >.
        </div>
        <div>
          Smart text:
          <span v-for="txt in smartText" :key="txt"> {{ txt }} </span>
        </div>
      </hi-row>
      <div v-for="slot in slots" :key="slot" class="flex-grow-1">
        <div>
          <span class="ui-text uppercase">slot: </span
          ><strong>{{ slot }}</strong>
        </div>
        <label>
          <textarea
            v-model="currentSlotValues[slot]"
            class="text grey-border flex-grow-1"
          ></textarea>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import HiRow from "@/components/scaffold/HiRow";
import marked from "marked";
export default {
  name: "EmailTemplateMarkdownEditor",
  components: { HiRow },
  props: {
    value: { type: String },
    template: { type: String },
    slotValues: { type: Object }
  },
  data() {
    return {
      currentSlotValues: {},
      timeId: null,
      smartText: ["{{name}}", "{{surname}}"]
    };
  },
  computed: {
    slots() {
      if (!this.template) return null;
      const slots = [];
      const regex = /<slot.*?name\s*=\s*"(?<name>.*?)".*?>(?<body>[\s\S]*?)<\/slot>/gim;
      const results = this.template.matchAll(regex);
      let result = {};
      while (!result.done) {
        result = results.next();
        if (result.value && result.value.groups) {
          const name = result.value.groups.name;
          // const body = result.value.groups.body;
          if (name) {
            slots.push(name);
          }
        }
      }
      return slots;
    },
    slotRegex() {
      if (!this.slots) return null;
      const reg = {};
      for (let i = 0; i < this.slots.length; i++) {
        const slot = this.slots[i];
        reg[slot] = new RegExp(
          `<slot.*?name\\s*=\\s*"${slot}".*?>[\\s\\S]*?<\\/slot>`,
          "gmi"
        );
      }
      return reg;
    }
  },
  methods: {
    lazyMark(slotChange) {
      if (this.timeId) clearTimeout(this.timeId);
      let output = this.template;
      if (!output) {
        this.$emit("input", null);
        return;
      }
      this.timeId = setTimeout(() => {
        for (let key in this.currentSlotValues) {
          const slot = this.currentSlotValues[key];
          // console.log(slot);
          // console.log(this.slotRegex[key]);
          output = output.replaceAll(
            this.slotRegex[key],
            marked(slot, { breaks: true })
          );
        }
        output = output.replaceAll(/<a\s/gi, `<a style="color:inherit" `);
        this.$emit("input", output);
        if (slotChange) {
          this.$emit("change", this.currentSlotValues);
        }
      }, 500);
    }
  },
  watch: {
    currentSlotValues: {
      deep: true,
      handler() {
        this.lazyMark(true);
      }
    },
    template: {
      immediate: true,
      handler() {
        this.lazyMark();
      }
    },
    //changed from outside
    slotValues: {
      immediate: true,
      handler(v) {
        this.currentSlotValues = v;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .text {
  width: 100%;
  height: 95%;
  border-radius: 5px;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  opacity: 0.6;
  transition: opacity 0.5s;
  resize: none;
}
::v-deep .grey-border {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
::v-deep .text:focus {
  outline: none;
  opacity: 1;
}
</style>
